/**
 * Node modules
 */
import styled from 'styled-components';

/**
 * Components
 */
import VendorAntCard from '../../Vendor/Ant/Card';

/**
 * Private modules
 */
import { scale } from '../.private';

/**
 * Private functions
 */
const getStyles = (props) => {
  const { state } = props;
  const styles = [];
  switch (state) {
    case 'fixed': {
      styles.push(`
        > .ant-card-head {
          background: white;
          position: fixed;
          width: 100%;
          z-index: 200;
        }
        > .ant-card-body {
          margin-top: ${scale.major(8)}px;
        }
      `);
      break;
    }
    case 'normal': {
      styles.push(`
        > .ant-card-body {
          padding: ${scale.major(3)}px;
        }
      `);
      break;
    }
    default: {
      styles.push(`
        > .ant-card-body {
          padding: 0;
        }
      `);
      break;
    }
  }
  return styles.join('');
};
export default styled(VendorAntCard)`
  /* stylelint-disable */
  ${getStyles};
  /* stylelint-enable */
  .ant-card-head-title {
    height: ${scale.major(8)}px;
  }
  .ant-card-loading-content {
    padding: ${scale.major(3)}px;
  }
`;
